import { render, staticRenderFns } from "./EventsFrame.vue?vue&type=template&id=b2becfd0&scoped=true"
import script from "./EventsFrame.vue?vue&type=script&lang=js"
export * from "./EventsFrame.vue?vue&type=script&lang=js"
import style0 from "./EventsFrame.vue?vue&type=style&index=0&id=b2becfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2becfd0",
  null
  
)

export default component.exports